module.exports = __webpack_public_path__ + "static/media/YF82_4.3bf6146c.jpg";